export function decodeJWT(token) {
    try {
        if (!token || typeof token !== 'string') {
            return null;
        }
        const parts = token.split('.');
        if (parts.length !== 3) {
            return null;
        }
        const payload = parts[1];
        const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
        return JSON.parse(decoded);
    } catch (error) {
        console.error('Error decoding JWT:', error);
        return null;
    }
}

export function getTokenExpiration(token) {
    const payload = decodeJWT(token);
    if (!payload || !payload.exp) {
        console.warn('Token does not contain exp claim');
        return null;
    }
    return payload.exp * 1000;
}

export function isTokenExpired(token) {
    const expiresAt = getTokenExpiration(token);
    if (!expiresAt) {
        return true;
    }
    return Date.now() >= expiresAt;
}
